<div class="select-conversion-container">
  <div class="title-bar" data-test="SelectConversionTitleBar">
    <h2>Select conversion target</h2>
  </div>

  <mat-dialog-content class="select-conversion-content">
    <app-request-target-search (incumbentSelected)="onSelectionChange($event)" [dropdownOptions]="[IncumbentDropdownOptions.CONTRACT_NUMBER]"/>
  </mat-dialog-content>

  <div class="navigation-buttons">
    <button mat-button (click)="closeModal()">Cancel</button>
    <button mat-raised-button color="primary" [disabled]="nextIsDisabled$ | async" (click)="nextButtonClicked()">Next</button>
  </div>
</div>
